import { render, staticRenderFns } from "./customer_distribution.vue?vue&type=template&id=67f8eeb5&scoped=true&"
import script from "./customer_distribution.vue?vue&type=script&lang=js&"
export * from "./customer_distribution.vue?vue&type=script&lang=js&"
import style0 from "./customer_distribution.vue?vue&type=style&index=0&id=67f8eeb5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f8eeb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f8eeb5')) {
      api.createRecord('67f8eeb5', component.options)
    } else {
      api.reload('67f8eeb5', component.options)
    }
    module.hot.accept("./customer_distribution.vue?vue&type=template&id=67f8eeb5&scoped=true&", function () {
      api.rerender('67f8eeb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_distribution/customer_distribution.vue"
export default component.exports